import { render } from "./FGCView.vue?vue&type=template&id=50b7681a&scoped=true&ts=true"
import script from "./FGCView.vue?vue&type=script&lang=ts"
export * from "./FGCView.vue?vue&type=script&lang=ts"

import "./FGCView.vue?vue&type=style&index=0&id=50b7681a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b7681a"]])

export default __exports__